import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import { news, NewsFilters } from '@toggle/toggle';

import { QUERY_NEWS_FILTERS } from '~/services/news/news-service';
import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const useNewsFilters = () =>
  useQuery({
    queryKey: [QUERY_NEWS_FILTERS],
    queryFn: ({ signal }) =>
      wretchRequest<NewsFilters>(news.filtersV4.path, {
        method: 'get',
        signal,
      }),
    select: res => res ?? [],
    staleTime: getTimeTillEndOfDayMs(),
  });
